import { ListPerson } from "@/pages/Private/pages/List/schema/list";

import { SenderRecipientOption } from "../components/SenderRecipientDropdown";

/**
 * Builds the recipient options for the chat "To" dropdown: one option per
 * channel the prospect is reachable on (email address and/or LinkedIn URL).
 */
export const buildRecipientOptions = (lead: ListPerson | undefined): SenderRecipientOption[] => {
	if (!lead?.prospect) {
		return [];
	}

	const options: SenderRecipientOption[] = [];

	if (lead.prospect.email) {
		options.push({
			id: `email-${lead.prospect.id}`,
			label: `${lead.prospect.name} (${lead.prospect.email})`,
			type: "email",
			value: lead.prospect.email,
		});
	}

	if (lead.prospect.linkedinUrl) {
		options.push({
			id: `li-${lead.prospect.id}`,
			label: `${lead.prospect.name} (LinkedIn)`,
			type: "linkedin",
			value: lead.prospect.linkedinUrl,
		});
	}

	return options;
};
